export const maxWidthPageStyles = {
  width: "100vw",
  maxWidth: "86em",
};
